import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=b4c91384&scoped=true&"
import script from "./indexs.vue?vue&type=script&lang=js&"
export * from "./indexs.vue?vue&type=script&lang=js&"
import style0 from "./indexs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./indexs.vue?vue&type=style&index=1&id=b4c91384&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c91384",
  null
  
)

export default component.exports